"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENCIES = void 0;
exports.minorUnitDigits = minorUnitDigits;
exports.isCurrency = isCurrency;
exports.CURRENCIES = [
    'BRL',
    'USD',
    'EUR',
    'CLP',
    'PEN',
    'COP',
    'MXN',
    'CAD',
    'JPY',
    'GBP',
    'DKK',
    'NOK',
    'SEK',
    'PYG',
    'CHF',
];
const ZERO_DECIMAL = new Set(['CLP', 'JPY', 'PYG']);
function minorUnitDigits(currency) {
    return ZERO_DECIMAL.has(currency) ? 0 : 2;
}
function isCurrency(value) {
    return exports.CURRENCIES.includes(value);
}
//# sourceMappingURL=currency.js.map